import { Outlet } from "react-router"

import Breadcrumb from "@/components/Breadcrumb/Breadcrumb"

export default function EnrolledCourses() {
  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="fw-bolder mb-0">
          <Breadcrumb />
        </h5>
      </div>

      <Outlet />
    </div>
  )
}
